"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionCodeEnum = exports.SectionActionTypes = void 0;
function cov_1jyxq450nd() {
  var path = "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/constant.js";
  var hash = "957248ee7445fe5485a22ed68c5f89282b439d15";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/constant.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 34
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "957248ee7445fe5485a22ed68c5f89282b439d15"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jyxq450nd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jyxq450nd();
var SectionActionTypes = exports.SectionActionTypes = (cov_1jyxq450nd().s[0]++, {
  SECTION_CHANGE_LANGUAGE: 'SECTION_CHANGE_LANGUAGE',
  SECTION_BEFORE_LOAD: 'SECTION_BEFORE_LOAD',
  SECTION_LOAD_SUCCESS: 'SECTION_LOAD_SUCCESS',
  SECTION_LOAD_ERROR: 'SECTION_LOAD_ERROR'
});
var SectionCodeEnum = exports.SectionCodeEnum = (cov_1jyxq450nd().s[1]++, {
  ALL_EVENTS: 'ALL_EVENTS'
});